import React, { useState, useEffect, useCallback } from 'react';
import { Card, CardContent, CardHeader, CardTitle } from '../ui/card';
import { Clock, Users, Activity, DollarSign, LogOut } from 'lucide-react';
import { useAdmin } from './AdminContext';

export default function ActivityTab({ refreshTrigger }) {
  const { adminFetch, API_URL } = useAdmin();
  const [activityLog, setActivityLog] = useState([]);

  const loadActivityLog = useCallback(async () => {
    try {
      const response = await adminFetch(`${API_URL}/api/v2/admin/activity-log`);
      if (response.ok) {
        const data = await response.json();
        setActivityLog(data.activities || []);
      }
    } catch (error) {
      console.error('Error loading activity log:', error);
    }
  }, [adminFetch, API_URL]);

  useEffect(() => { loadActivityLog(); }, [loadActivityLog, refreshTrigger]);

  return (
    <Card className="bg-slate-800 border-slate-700" data-testid="activity-tab">
      <CardHeader>
        <CardTitle className="text-white flex items-center gap-2">
          <Clock className="h-5 w-5 text-blue-400" />
          Recent Activity
        </CardTitle>
      </CardHeader>
      <CardContent>
        <div className="space-y-3 max-h-[600px] overflow-y-auto">
          {activityLog.length > 0 ? activityLog.map((activity, index) => (
            <div key={index} className="flex items-start gap-4 p-3 bg-slate-700/30 rounded-lg">
              <div className={`w-10 h-10 rounded-full flex items-center justify-center ${
                activity.type === 'registration' ? 'bg-green-500/20' :
                activity.type === 'workout' ? 'bg-blue-500/20' :
                activity.type === 'payment' ? 'bg-purple-500/20' :
                activity.type === 'login' ? 'bg-cyan-500/20' :
                'bg-slate-600'
              }`}>
                {activity.type === 'registration' && <Users className="h-5 w-5 text-green-400" />}
                {activity.type === 'workout' && <Activity className="h-5 w-5 text-blue-400" />}
                {activity.type === 'payment' && <DollarSign className="h-5 w-5 text-purple-400" />}
                {activity.type === 'login' && <LogOut className="h-5 w-5 text-cyan-400" />}
              </div>
              <div className="flex-1">
                <p className="text-white">{activity.details || activity.description}</p>
                <p className="text-slate-400 text-sm">{activity.email || activity.user_email} ({activity.user})</p>
              </div>
              <p className="text-slate-500 text-xs">
                {activity.timestamp ? new Date(activity.timestamp).toLocaleString() : 'N/A'}
              </p>
            </div>
          )) : (
            <div className="text-center py-8 text-slate-400">No recent activity</div>
          )}
        </div>
      </CardContent>
    </Card>
  );
}
